<template>
  <div class="recommend-list">
    <div class="suggest-title">
      <span>推荐学习</span>
    </div>

    <ul class="suggest-learn-list">
      <li v-for="item of list" :key="item.id">
        <img :src="item.img_logo" alt="" />
        <div class="content">
          <div class="class-name">{{ item.name }}</div>
          <Label :label="item.label_id" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import Label from '../components/label'

import { apiCourseRecomend } from '@/api/IELTScourse'

export default {
  components: {
    Label
  },
  filters: {
    lableText(val) {
      return ['', 'Speaking', 'Listening', 'Writing', 'Reading'][val]
    }
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      const { data } = await apiCourseRecomend()
      this.list = data
    }
  }
}
</script>

<style scoped lang="scss">
$grayFont: #a5a5ac;
.recommend-list {
  .suggest-title {
    > span {
      font-size: 14px;
      color: #ffffff;
    }
  }
  .suggest-learn-list {
    > li {
      display: flex;
      margin-top: 16px;
      > img {
        width: 104px;
        height: 58px;
        object-fit: cover;
        border-radius: 5px;
      }
      .content {
        margin-left: 12px;
        .class-name {
          color: #ffffff;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
